import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { useInvoiceAppFetcher } from './fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
};

export enum Action {
  Call = 'CALL',
  Email = 'EMAIL',
  Sms = 'SMS',
}

export type AdminInvoices = {
  __typename?: 'AdminInvoices';
  results: Array<Invoice>;
  totalCount: Scalars['Int']['output'];
};

export type AdminScenarios = {
  __typename?: 'AdminScenarios';
  results: Array<Scenario>;
  totalCount: Scalars['Int']['output'];
};

export type AdminUserInput = {
  plan?: InputMaybe<UserPlan>;
  role?: InputMaybe<Role>;
};

export type AdminUsers = {
  __typename?: 'AdminUsers';
  results: Array<User>;
  totalCount: Scalars['Int']['output'];
};

export type ArchiveResult = {
  __typename?: 'ArchiveResult';
  /** IDs of invoices that couldn't be archived. */
  failed: Array<Scalars['String']['output']>;
};

export type AresResult = {
  __typename?: 'AresResult';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AttachClaimsToBatchUploadInput = {
  batchUploadId: Scalars['String']['input'];
  claims: Array<BatchedClaimInput>;
  scenarioId: Scalars['String']['input'];
};

export type AttachInvoicesToBatchUploadInput = {
  batchUploadId: Scalars['String']['input'];
  invoices: Array<BatchedInvoiceInput>;
  scenarioId: Scalars['String']['input'];
};

export type AuthenticateBankInput = {
  /** URL to redirect user to after successful authentication. */
  callbackUrl: Scalars['String']['input'];
  paymentProvider: Scalars['String']['input'];
};

export type Bank = {
  __typename?: 'Bank';
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paymentProvider: Scalars['String']['output'];
};

export type BankAuthentication = {
  __typename?: 'BankAuthentication';
  /** Bank authentication URL */
  redirectUrl: Scalars['String']['output'];
};

export type BankConnection = {
  __typename?: 'BankConnection';
  bankLogoUrl?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  status: BankConnectionStatus;
};

export enum BankConnectionStatus {
  Expired = 'EXPIRED',
  Valid = 'VALID',
}

export type BankTransaction = {
  __typename?: 'BankTransaction';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  debtorAccount?: Maybe<Scalars['String']['output']>;
  debtorAccountName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export enum BatchInvoiceUploadCategory {
  AlreadyCompleted = 'ALREADY_COMPLETED',
  Archived = 'ARCHIVED',
  Ignored = 'IGNORED',
  New = 'NEW',
  PartiallySettled = 'PARTIALLY_SETTLED',
  Reminding = 'REMINDING',
  Settled = 'SETTLED',
}

export type BatchUpload = {
  __typename?: 'BatchUpload';
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  invoices: Array<Invoice>;
  invoicesCount: Scalars['Int']['output'];
  paymentId?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  planPaid: Scalars['Boolean']['output'];
  /** Final price including discount */
  price?: Maybe<Scalars['Int']['output']>;
  scenario?: Maybe<Scenario>;
  type: BatchUploadType;
};

export type BatchUploadDiscountArgs = {
  plan: Plan;
};

export type BatchUploadPriceArgs = {
  plan: Plan;
};

export enum BatchUploadType {
  Export = 'EXPORT',
  Pdf = 'PDF',
}

export type BatchedClaimInput = {
  amount: Scalars['Int']['input'];
  amountDue: Scalars['Int']['input'];
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customer: CustomerCreateInput;
  dueDate: Scalars['DateTime']['input'];
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  variableSymbol?: InputMaybe<Scalars['String']['input']>;
  vendor: VendorCreateInput;
};

export type BatchedInvoiceInput = {
  amount: Scalars['Int']['input'];
  amountDue: Scalars['Int']['input'];
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['DateTime']['input'];
  issueDate: Scalars['DateTime']['input'];
  number: Scalars['String']['input'];
  variableSymbol?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmInvoiceInput = {
  amount: Scalars['Int']['input'];
  amountDue: Scalars['Int']['input'];
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerNote?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['DateTime']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  issueDate: Scalars['DateTime']['input'];
  items: Array<InvoiceItemInput>;
  number: Scalars['String']['input'];
  swift?: InputMaybe<Scalars['String']['input']>;
  variableSymbol?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type CreateBatchUploadInput = {
  type: BatchUploadType;
};

export type CreateInvoiceManuallyInput = {
  /** Total with VAT */
  amount: Scalars['Int']['input'];
  /** Total VAT */
  amountVat?: InputMaybe<Scalars['Int']['input']>;
  /** Total without VAT */
  amountWithoutVat?: InputMaybe<Scalars['Int']['input']>;
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerNote?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['DateTime']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  issueDate: Scalars['DateTime']['input'];
  items: Array<InvoiceItemInput>;
  number: Scalars['String']['input'];
  swift?: InputMaybe<Scalars['String']['input']>;
  taxPayer: Scalars['Boolean']['input'];
  /** A tax point is the date on which VAT becomes due on a particular transaction */
  taxPoint?: InputMaybe<Scalars['DateTime']['input']>;
  variableSymbol?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type CreateInvoicesFromMappedDataInput = {
  invoices: Scalars['JSON']['input'];
  scenarioId: Scalars['String']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  remindingTone: RemindingTone;
  taxId?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
};

export type CustomerCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  remindingTone?: InputMaybe<RemindingTone>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  remindingTone?: InputMaybe<RemindingTone>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type EditInvoiceInput = {
  /** Total with VAT */
  amount: Scalars['Int']['input'];
  /** Total VAT */
  amountVat?: InputMaybe<Scalars['Int']['input']>;
  /** Total without VAT */
  amountWithoutVat?: InputMaybe<Scalars['Int']['input']>;
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerNote?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['DateTime']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  issueDate: Scalars['DateTime']['input'];
  items: Array<InvoiceItemInput>;
  number: Scalars['String']['input'];
  swift?: InputMaybe<Scalars['String']['input']>;
  taxPayer: Scalars['Boolean']['input'];
  /** A tax point is the date on which VAT becomes due on a particular transaction */
  taxPoint?: InputMaybe<Scalars['DateTime']['input']>;
  variableSymbol?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type EscalateUnpaidInvoiceInput = {
  invoiceId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type Invoice = {
  __typename?: 'Invoice';
  amount?: Maybe<Scalars['Int']['output']>;
  amountDue?: Maybe<Scalars['Int']['output']>;
  amountVat?: Maybe<Scalars['Int']['output']>;
  amountWithoutVat?: Maybe<Scalars['Int']['output']>;
  annotationComplete: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankNumber?: Maybe<Scalars['String']['output']>;
  bankTransactions: Array<BankTransaction>;
  batchUpload?: Maybe<BatchUpload>;
  batchUploadId?: Maybe<Scalars['String']['output']>;
  canBeArchived: Scalars['Boolean']['output'];
  claim: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdManually: Scalars['Boolean']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  customerNote?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Is true if the invoice was processed in Rossum, otherwise false. */
  isAnnotated: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  items: Array<InvoiceItem>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  owner: User;
  paymentId?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  planPaid: Scalars['Boolean']['output'];
  /** Final price for reminding of this invoice including discount. */
  price?: Maybe<Scalars['Int']['output']>;
  remindingTone: RemindingTone;
  scenario?: Maybe<Scenario>;
  scheduledActions: Array<ScheduledAction>;
  settled: Scalars['Boolean']['output'];
  status: InvoiceStatus;
  swift?: Maybe<Scalars['String']['output']>;
  taxPayer: Scalars['Boolean']['output'];
  /** A tax point is the date on which VAT becomes due on a particular transaction */
  taxPoint?: Maybe<Scalars['DateTime']['output']>;
  variableSymbol?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Vendor>;
};

export type InvoiceDiscountArgs = {
  plan: Plan;
};

export type InvoicePriceArgs = {
  plan: Plan;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  name: Scalars['String']['output'];
  pricePerUnit: Scalars['Int']['output'];
  priceSum: Scalars['Int']['output'];
  priceWithoutVat?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Float']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  vatRate?: Maybe<Scalars['String']['output']>;
};

export type InvoiceItemInput = {
  name: Scalars['String']['input'];
  pricePerUnit: Scalars['Int']['input'];
  priceSum: Scalars['Int']['input'];
  priceWithoutVat?: InputMaybe<Scalars['Int']['input']>;
  quantity?: Scalars['Float']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  vatRate?: InputMaybe<Scalars['String']['input']>;
};

/** A model is a hard-coded object created by developers directly for a specific input data format (e.g. XML export from Pohoda accounting software). The model contains logic on how to read input data and how to create invoices from it. */
export type InvoiceModel = {
  __typename?: 'InvoiceModel';
  fields: Array<InvoiceModelField>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InvoiceModelField = {
  __typename?: 'InvoiceModelField';
  name: ModelFieldName;
  required: Scalars['Boolean']['output'];
};

export enum InvoiceStatus {
  Archived = 'ARCHIVED',
  AwaitingPayment = 'AWAITING_PAYMENT',
  AwaitingVerification = 'AWAITING_VERIFICATION',
  Complete = 'COMPLETE',
  MissingRequiredData = 'MISSING_REQUIRED_DATA',
  Processing = 'PROCESSING',
  Reminding = 'REMINDING',
  Settled = 'SETTLED',
}

export type LeadCustomerModel = {
  __typename?: 'LeadCustomerModel';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  remindingTone: RemindingTone;
  taxId?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
};

export type LeadInput = {
  email: Scalars['String']['input'];
  invoice: LeadInvoiceInput;
};

export type LeadInvoiceCustomerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type LeadInvoiceInput = {
  /** centesimal amount */
  amount: Scalars['Int']['input'];
  /** Total VAT */
  amountVat?: InputMaybe<Scalars['Int']['input']>;
  /** Total without VAT */
  amountWithoutVat?: InputMaybe<Scalars['Int']['input']>;
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customer: LeadInvoiceCustomerInput;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  items: Array<InvoiceItemInput>;
  number: Scalars['String']['input'];
  swift?: InputMaybe<Scalars['String']['input']>;
  taxPayer: Scalars['Boolean']['input'];
  /** A tax point is the date on which VAT becomes due on a particular transaction */
  taxPoint?: InputMaybe<Scalars['DateTime']['input']>;
  variableSymbol: Scalars['String']['input'];
  vendor: LeadInvoiceVendorInput;
};

export type LeadInvoiceModel = {
  __typename?: 'LeadInvoiceModel';
  amount?: Maybe<Scalars['Int']['output']>;
  amountDue?: Maybe<Scalars['Int']['output']>;
  amountVat?: Maybe<Scalars['Int']['output']>;
  amountWithoutVat?: Maybe<Scalars['Int']['output']>;
  annotationComplete: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankNumber?: Maybe<Scalars['String']['output']>;
  batchUploadId?: Maybe<Scalars['String']['output']>;
  claim: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdManually: Scalars['Boolean']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer: LeadCustomerModel;
  customerNote?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  items: Array<InvoiceItem>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  planPaid: Scalars['Boolean']['output'];
  remindingTone: RemindingTone;
  settled: Scalars['Boolean']['output'];
  swift?: Maybe<Scalars['String']['output']>;
  taxPayer: Scalars['Boolean']['output'];
  /** A tax point is the date on which VAT becomes due on a particular transaction */
  taxPoint?: Maybe<Scalars['DateTime']['output']>;
  variableSymbol?: Maybe<Scalars['String']['output']>;
  vendor: LeadVendorModel;
};

export type LeadInvoiceVendorInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  registry?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type LeadVendorModel = {
  __typename?: 'LeadVendorModel';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  registry?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
};

export enum MessageKind {
  Sms = 'SMS',
}

export enum ModelFieldName {
  Co = 'CO',
  Email = 'EMAIL',
  Identifikator = 'IDENTIFIKATOR',
  Kam = 'KAM',
  Kdy = 'KDY',
  Kolik = 'KOLIK',
  Telefon = 'TELEFON',
  Upominany = 'UPOMINANY',
  Varsymbol = 'VARSYMBOL',
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Bulk archive invoice. Returns ID of invoices that couldn't be archived. Invoice with status REMINDING can't be archived, reminding must be ended first. */
  archive: ArchiveResult;
  /** Attaches claims to existing batch upload (created with `createBatchUpload`). To get the structured data of tha claims, use the `/upload-xml` endpoint. */
  attachClaimsToBatchUpload: BatchUpload;
  /** Attaches invoices to existing batch upload (created with `createBatchUpload`). To get the structured data of the invoices, use the `/upload-xml` endpoint. */
  attachInvoicesToBatchUpload: BatchUpload;
  /** Updates invoice and marks it as verified. Used to provide details for invoices uploaded via rossum.ai. Once verified, the invoice is ready to be paid as long as it has all the required details. */
  confirmInvoice: Invoice;
  /** Returns bank authentication URL. Redirect user to that URL and let him to authenticate to his bank. After successful authentication the user is redirected to `callbackUrl`. */
  connectBank: BankAuthentication;
  /** Create a payment for a batch upload. Returns Stripe client secret if payment is required, otherwise returns null. */
  createBatchPayment: PlanPayment;
  /** Creates a new empty batch upload, you can then add invoices to it. */
  createBatchUpload: BatchUpload;
  /** Create a new customer. */
  createCustomer: Customer;
  /** Creates a new blank invoice. */
  createInvoice: Invoice;
  /** Creates a new invoice. */
  createInvoiceManually: Invoice;
  /** Accepts invoices data in JSON format and scenario according to which the data will be processed. Invoices data must be compatible with the scenario's model (check fields available on the model). It is good for when you have your data in custom table-like format - just map you columns to model's fieldsand load it (creation of custom model and scenario might be needed). */
  createInvoicesFromJson: BatchUpload;
  /** Save lead with invoice data. */
  createLead?: Maybe<LeadInvoiceModel>;
  /** Create a payment for single invoice. Returns Stripe client secret if payment is required, otherwise returns null. */
  createPayment: PlanPayment;
  /** Create new scenario. Only back-office user can do this. */
  createScenario: Scenario;
  /** Create a new vendor. */
  createVendor: Vendor;
  /** Delete existing scenario. Only back-office user can do this. */
  deleteScenario: Scalars['String']['output'];
  /** Remove consent for contacting the user regarding the unsupported file. Use ID from the upload response. */
  denyUnsupportedFileContactConsent?: Maybe<SuccessResult>;
  /** Revokes bank authentication and removes the bank connection record. */
  disconnectBank: Scalars['String']['output'];
  /** Edits manually created invoice. */
  editInvoice: Invoice;
  /** Marks all scheduled actions of the invoice as completed. */
  endReminding: Invoice;
  /** Request for help with unpaid invoice. Sends e-mail to back office. Back office user can then contact the requester to agree on the next steps. */
  escalateUnpaidInvoice: Scalars['Boolean']['output'];
  /** Request new plan for invoice. Only available for invoices with trial plan. */
  requestNewPlan: Invoice;
  /** Delete current user where applicable. */
  resendVerificationEmail: Scalars['Boolean']['output'];
  /** Changes the due amount of the invoice. If set to 0, the invoice is marked as paid and all the scheduled actions are marked as completed. */
  setDueAmount: Invoice;
  /** Update role/plan of any user. */
  updateAdminUser: User;
  /** Update existing customer. */
  updateCustomer: Customer;
  /** Update existing scenario. Only back-office user can do this. */
  updateScenario: Scenario;
  /** Updates a scheduled action. */
  updateScheduledAction: ScheduledAction;
  /** Update current user. */
  updateUser: User;
  /** Update existing vendor. */
  updateVendor: Vendor;
};

export type MutationArchiveArgs = {
  invoiceIds: Array<Scalars['String']['input']>;
};

export type MutationAttachClaimsToBatchUploadArgs = {
  input: AttachClaimsToBatchUploadInput;
};

export type MutationAttachInvoicesToBatchUploadArgs = {
  input: AttachInvoicesToBatchUploadInput;
};

export type MutationConfirmInvoiceArgs = {
  input: ConfirmInvoiceInput;
};

export type MutationConnectBankArgs = {
  input: AuthenticateBankInput;
};

export type MutationCreateBatchPaymentArgs = {
  id: Scalars['String']['input'];
  plan: Plan;
};

export type MutationCreateBatchUploadArgs = {
  input: CreateBatchUploadInput;
};

export type MutationCreateCustomerArgs = {
  customer: CustomerCreateInput;
};

export type MutationCreateInvoiceManuallyArgs = {
  input: CreateInvoiceManuallyInput;
};

export type MutationCreateInvoicesFromJsonArgs = {
  input: CreateInvoicesFromMappedDataInput;
};

export type MutationCreateLeadArgs = {
  input: LeadInput;
};

export type MutationCreatePaymentArgs = {
  id: Scalars['String']['input'];
  plan: Plan;
};

export type MutationCreateScenarioArgs = {
  input: ScenarioCreateInput;
};

export type MutationCreateVendorArgs = {
  vendor: VendorCreateInput;
};

export type MutationDeleteScenarioArgs = {
  id: Scalars['String']['input'];
};

export type MutationDenyUnsupportedFileContactConsentArgs = {
  id: Scalars['String']['input'];
};

export type MutationDisconnectBankArgs = {
  id: Scalars['String']['input'];
};

export type MutationEditInvoiceArgs = {
  input: EditInvoiceInput;
};

export type MutationEndRemindingArgs = {
  invoiceId: Scalars['String']['input'];
};

export type MutationEscalateUnpaidInvoiceArgs = {
  input: EscalateUnpaidInvoiceInput;
};

export type MutationRequestNewPlanArgs = {
  id: Scalars['String']['input'];
};

export type MutationSetDueAmountArgs = {
  amountDue: Scalars['Float']['input'];
  id: Scalars['String']['input'];
};

export type MutationUpdateAdminUserArgs = {
  id: Scalars['String']['input'];
  input: AdminUserInput;
};

export type MutationUpdateCustomerArgs = {
  customer: CustomerUpdateInput;
};

export type MutationUpdateScenarioArgs = {
  input: ScenarioUpdateInput;
};

export type MutationUpdateScheduledActionArgs = {
  input: ScheduledActionUpdateInput;
};

export type MutationUpdateUserArgs = {
  input: UserInput;
};

export type MutationUpdateVendorArgs = {
  vendor: VendorUpdateInput;
};

export enum Plan {
  Standard = 'STANDARD',
  Trial = 'TRIAL',
}

export type PlanPayment = {
  __typename?: 'PlanPayment';
  clientSecret?: Maybe<Scalars['String']['output']>;
  paymentRequired: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Get any invoice by id. Only available for back-office users with correct permissions. */
  adminInvoice: Invoice;
  /** Get all invoices. Only available for back-office users with correct permissions. */
  adminInvoices: AdminInvoices;
  /** Get any scenario by id. Only available for back-office users with correct permissions. */
  adminScenario: Scenario;
  /** Get all scenarios. Only available for back-office users with correct permissions. */
  adminScenarios: AdminScenarios;
  /** List users. Only available for back-office users with correct permissions. */
  adminUsers: AdminUsers;
  /** Get status of the auth. */
  authStatus: Scalars['String']['output'];
  /** A helper query to provide the BatchInvoiceUploadCategory enum to the client. This is used in `category` attribute of /upload-xml endpoint. */
  availableBatchInvoiceUploadCategories: BatchInvoiceUploadCategory;
  /** Get list of your connected banks. */
  bankConnections: Array<BankConnection>;
  /** Get batch upload by id. */
  batchUpload: BatchUpload;
  /** Get customer by id. */
  customer: Customer;
  /** Get all customers for current user. */
  customers: Array<Customer>;
  /** Get invoice by id. */
  invoice: Invoice;
  /** Get all models available to be used with scenarios. */
  invoiceModels: Array<InvoiceModel>;
  /** Get all invoices for current user. */
  invoices: Array<Invoice>;
  /** Get lead invoice data by id. */
  leadInvoice: LeadInvoiceModel;
  /** Query ARES service for structured information about provided vatId (IČ). Provider's API has a rate limitation and could result in permanent ban if abused - use this query accordingly. */
  queryAres?: Maybe<AresResult>;
  /** Gets all received messages. */
  receivedMessages: Array<ReceivedMessage>;
  /** Get scenario by id. */
  scenario: Scenario;
  /** Get list of available scenario plans. */
  scenarioPlans: Array<ScenarioPlan>;
  /** Get scenarios for current user. */
  scenarios: Array<Scenario>;
  /** Gets a single scheduled action by id. */
  scheduledAction: ScheduledAction;
  /** Gets all actions scheduled to be performed today. */
  scheduledActionsDoneToday: Array<ScheduledAction>;
  /** Gets all actions scheduled to be performed today, or unfinished from earlier. */
  scheduledActionsForToday: Array<ScheduledAction>;
  /** Get status of the API. */
  status: Scalars['String']['output'];
  /** Get list of banks supported by FinBricks. */
  supportedBanks: Array<Bank>;
  /** Get current user. */
  user: User;
  /** Get vendor by id. */
  vendor: Vendor;
  /** Get all vendors for current user. */
  vendors: Array<Vendor>;
};

export type QueryAdminInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};

export type QueryAdminInvoicesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  claim?: InputMaybe<Scalars['Boolean']['input']>;
  query?: Scalars['String']['input'];
  skip?: Scalars['Float']['input'];
  take?: Scalars['Float']['input'];
};

export type QueryAdminScenarioArgs = {
  id: Scalars['String']['input'];
};

export type QueryAdminScenariosArgs = {
  query?: Scalars['String']['input'];
  skip?: Scalars['Float']['input'];
  take?: Scalars['Float']['input'];
};

export type QueryAdminUsersArgs = {
  query?: Scalars['String']['input'];
  skip?: Scalars['Float']['input'];
  take?: Scalars['Float']['input'];
};

export type QueryBatchUploadArgs = {
  id: Scalars['String']['input'];
};

export type QueryCustomerArgs = {
  id: Scalars['String']['input'];
};

export type QueryInvoiceArgs = {
  id: Scalars['String']['input'];
};

export type QueryInvoicesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  claim?: InputMaybe<Scalars['Boolean']['input']>;
  createdManually?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryLeadInvoiceArgs = {
  id: Scalars['String']['input'];
};

export type QueryQueryAresArgs = {
  vatId: Scalars['String']['input'];
};

export type QueryScenarioArgs = {
  id: Scalars['String']['input'];
};

export type QueryScheduledActionArgs = {
  id: Scalars['String']['input'];
};

export type QueryVendorArgs = {
  id: Scalars['String']['input'];
};

/** Represents SMS message sent to Upominej phone number. */
export type ReceivedMessage = {
  __typename?: 'ReceivedMessage';
  createdAt: Scalars['DateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['String']['output'];
  kind: MessageKind;
  receivedAt: Scalars['DateTime']['output'];
  relevantScheduledActions: Array<ScheduledAction>;
  text: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export enum RemindingTone {
  Firm = 'FIRM',
  Neutral = 'NEUTRAL',
  Polite = 'POLITE',
}

export enum Role {
  Admin = 'ADMIN',
  User = 'USER',
}

/** The scenario is used to customize reminding to user's needs. You can define your own reminding texts. Scenarios are created by back-office user in cooperation with the user. */
export type Scenario = {
  __typename?: 'Scenario';
  id: Scalars['String']['output'];
  model: InvoiceModel;
  name: Scalars['String']['output'];
  plan: ScenarioPlan;
  static: Scalars['Boolean']['output'];
  subject: Array<Scalars['String']['output']>;
  textCall: Array<Scalars['String']['output']>;
  textEmail: Array<Scalars['String']['output']>;
  textSms: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type ScenarioCreateInput = {
  modelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  plan: ScenarioPlanName;
  subject: Array<Scalars['String']['input']>;
  textCall: Array<Scalars['String']['input']>;
  textEmail: Array<Scalars['String']['input']>;
  textSms: Array<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ScenarioPlan = {
  __typename?: 'ScenarioPlan';
  call: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  name: ScenarioPlanName;
  sms: Scalars['Int']['output'];
};

export enum ScenarioPlanName {
  Plan_331 = 'PLAN_331',
  Plan_551 = 'PLAN_551',
}

export type ScenarioUpdateInput = {
  id: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  plan: ScenarioPlanName;
  subject: Array<Scalars['String']['input']>;
  textCall: Array<Scalars['String']['input']>;
  textEmail: Array<Scalars['String']['input']>;
  textSms: Array<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledAction = {
  __typename?: 'ScheduledAction';
  action: Action;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  invoice: Invoice;
  invoiceClaim: Scalars['Boolean']['output'];
  invoiceId: Scalars['String']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  recommendedMessage?: Maybe<Scalars['String']['output']>;
  recommendedSubject?: Maybe<Scalars['String']['output']>;
  scheduledAt: Scalars['DateTime']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
  templateNoPayment?: Maybe<Scalars['String']['output']>;
  templatePartialPayment?: Maybe<Scalars['String']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type ScheduledActionUpdateInput = {
  doneAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SuccessResult = {
  __typename?: 'SuccessResult';
  success: Scalars['Boolean']['output'];
};

export type User = {
  __typename?: 'User';
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankNumber?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  defaultRemindingTone: RemindingTone;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  plan: UserPlan;
  remindersCount: Scalars['Int']['output'];
  remindersLimit?: Maybe<Scalars['Int']['output']>;
  role: Role;
  streetAddress?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
  /** DIČ */
  taxId?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type UserInput = {
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankNumber?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  defaultRemindingTone?: InputMaybe<RemindingTone>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  /** DIČ */
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum UserPlan {
  Complete = 'COMPLETE',
  Optimal = 'OPTIMAL',
  Trial = 'TRIAL',
}

export type Vendor = {
  __typename?: 'Vendor';
  address?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
};

export type VendorCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type VendorUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type LeadInvoiceFragment = {
  __typename?: 'LeadInvoiceModel';
  number?: string | null;
  variableSymbol?: string | null;
  amount?: number | null;
  amountWithoutVat?: number | null;
  amountVat?: number | null;
  bankAccount?: string | null;
  bankNumber?: string | null;
  currency?: string | null;
  iban?: string | null;
  dueDate?: any | null;
  issueDate?: any | null;
  taxPoint?: any | null;
  taxPayer: boolean;
  swift?: string | null;
  vendor: {
    __typename?: 'LeadVendorModel';
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    address?: string | null;
    registry?: string | null;
    taxId?: string | null;
    vatId?: string | null;
  };
  customer: {
    __typename?: 'LeadCustomerModel';
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    address?: string | null;
    taxId?: string | null;
    vatId?: string | null;
  };
  items: Array<{
    __typename?: 'InvoiceItem';
    name: string;
    pricePerUnit: number;
    priceSum: number;
    quantity: number;
    unit?: string | null;
    vatRate?: string | null;
    priceWithoutVat?: number | null;
  }>;
};

export type LeadInvoiceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type LeadInvoiceQuery = {
  __typename?: 'Query';
  leadInvoice: {
    __typename?: 'LeadInvoiceModel';
    number?: string | null;
    variableSymbol?: string | null;
    amount?: number | null;
    amountWithoutVat?: number | null;
    amountVat?: number | null;
    bankAccount?: string | null;
    bankNumber?: string | null;
    currency?: string | null;
    iban?: string | null;
    dueDate?: any | null;
    issueDate?: any | null;
    taxPoint?: any | null;
    taxPayer: boolean;
    swift?: string | null;
    vendor: {
      __typename?: 'LeadVendorModel';
      name?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      address?: string | null;
      registry?: string | null;
      taxId?: string | null;
      vatId?: string | null;
    };
    customer: {
      __typename?: 'LeadCustomerModel';
      name?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      address?: string | null;
      taxId?: string | null;
      vatId?: string | null;
    };
    items: Array<{
      __typename?: 'InvoiceItem';
      name: string;
      pricePerUnit: number;
      priceSum: number;
      quantity: number;
      unit?: string | null;
      vatRate?: string | null;
      priceWithoutVat?: number | null;
    }>;
  };
};

export type CreateLeadMutationVariables = Exact<{
  input: LeadInput;
}>;

export type CreateLeadMutation = {
  __typename?: 'Mutation';
  createLead?: {
    __typename?: 'LeadInvoiceModel';
    number?: string | null;
    variableSymbol?: string | null;
    amount?: number | null;
    amountWithoutVat?: number | null;
    amountVat?: number | null;
    bankAccount?: string | null;
    bankNumber?: string | null;
    currency?: string | null;
    iban?: string | null;
    dueDate?: any | null;
    issueDate?: any | null;
    taxPoint?: any | null;
    taxPayer: boolean;
    swift?: string | null;
    vendor: {
      __typename?: 'LeadVendorModel';
      name?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      address?: string | null;
      registry?: string | null;
      taxId?: string | null;
      vatId?: string | null;
    };
    customer: {
      __typename?: 'LeadCustomerModel';
      name?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      address?: string | null;
      taxId?: string | null;
      vatId?: string | null;
    };
    items: Array<{
      __typename?: 'InvoiceItem';
      name: string;
      pricePerUnit: number;
      priceSum: number;
      quantity: number;
      unit?: string | null;
      vatRate?: string | null;
      priceWithoutVat?: number | null;
    }>;
  } | null;
};

export const LeadInvoiceFragmentDoc = `
    fragment LeadInvoice on LeadInvoiceModel {
  number
  variableSymbol
  amount
  amountWithoutVat
  amountVat
  bankAccount
  bankNumber
  currency
  iban
  dueDate
  issueDate
  taxPoint
  taxPayer
  swift
  vendor {
    name
    email
    phoneNumber
    address
    registry
    taxId
    vatId
  }
  customer {
    name
    email
    phoneNumber
    address
    taxId
    vatId
  }
  items {
    name
    pricePerUnit
    priceSum
    quantity
    unit
    vatRate
    priceWithoutVat
  }
}
    `;
export const LeadInvoiceDocument = `
    query leadInvoice($id: String!) {
  leadInvoice(id: $id) {
    ...LeadInvoice
  }
}
    ${LeadInvoiceFragmentDoc}`;

export const useLeadInvoiceQuery = <TData = LeadInvoiceQuery, TError = { message: string; code: number }>(
  variables: LeadInvoiceQueryVariables,
  options?: Omit<UseQueryOptions<LeadInvoiceQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<LeadInvoiceQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<LeadInvoiceQuery, TError, TData>({
    queryKey: ['leadInvoice', variables],
    queryFn: useInvoiceAppFetcher<LeadInvoiceQuery, LeadInvoiceQueryVariables>(LeadInvoiceDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useLeadInvoiceQuery.document = LeadInvoiceDocument;

useLeadInvoiceQuery.getKey = (variables: LeadInvoiceQueryVariables) => ['leadInvoice', variables];

export const CreateLeadDocument = `
    mutation createLead($input: LeadInput!) {
  createLead(input: $input) {
    ...LeadInvoice
  }
}
    ${LeadInvoiceFragmentDoc}`;

export const useCreateLeadMutation = <TError = { message: string; code: number }, TContext = unknown>(
  options?: UseMutationOptions<CreateLeadMutation, TError, CreateLeadMutationVariables, TContext>,
) => {
  return useMutation<CreateLeadMutation, TError, CreateLeadMutationVariables, TContext>({
    mutationKey: ['createLead'],
    mutationFn: useInvoiceAppFetcher<CreateLeadMutation, CreateLeadMutationVariables>(CreateLeadDocument),
    ...options,
  });
};
